import * as Draft from 'draft-js';

import { ALL_DECORATORS } from './decorators';
import {
  normalizeFromServerToRawDraftState,
  NormalizeToRawDraftStateParams,
} from './normalize';

export const editorStateFromServerString = (
  params: NormalizeToRawDraftStateParams
): Draft.EditorState => {
  const formulaState = normalizeFromServerToRawDraftState(params);

  return Draft.EditorState.createWithContent(
    Draft.convertFromRaw(formulaState),
    ALL_DECORATORS
  );
};
